export default __webpack_public_path__ + "static/media/all-temples-annavaram-card-img.340b225e.png";